import * as R from 'ramda'
import * as actionTypes from './actionTypes.js'

// str -> str -> obj -> Action
const createAction = model => actionType => {
  const actionCreator = (payload, meta = {}) => {
    const action = {
      type: actionType,
      meta: { model, pk: null, ...meta },
      payload,
    }
    if (R.is(Object, payload)) {
      const { pk = null, ...data } = payload
      action.meta.pk = pk
      action.payload = data
    }
    return action
  }

  actionCreator.toString = () => actionType
  actionCreator.type = actionType
  return actionCreator
}

// str -> str
const camelCase = R.pipe(
  R.toLower,
  R.replace(/[- _]+(\w)/g, m => m[1].toUpperCase()),
)

// object of action creators for named model
// str -> {str: obj -> Action}
export const modelActions = model =>
  R.pipe(
    R.toPairs,
    R.map(([name, actionType]) => [
      camelCase(name),
      createAction(model)(actionType),
    ]),
    R.fromPairs,
  )(actionTypes)
